
export default {
  maps: {
    'pageTitle': 'OpenRouteService térképek',
    'Places': 'Helyek',
    'isochrones': 'Izokron vonalak',
    'placeNameRequired': 'Meg kell adni egy helynevet',
    'altitude': 'Magasságváltozás',
    'settings': 'Beállítások',
    'toggleAccessibleMode': 'Kisegítő lehetőségek bekapcsolása',
    'aboutTitle': 'Az OpenRouteService (ORS) névjegye',
    'updateSearch': 'Keresés ezen a területen',
    'updateSearchAfterZoomOrCenterChange': 'Keresés frissítése nagyítás vagy a középpont módosítása után',
    'pageNotFound': 'Az oldal nem található. Ellenőrizze, hogy az URL nem hiányos vagy helytelen'
  }
}
